export const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

export const initials = (name = "") =>
  String(name).split(" ").map((w) => w[0]).filter(Boolean).slice(0, 2).join("").toUpperCase();

// Coerce any Firestore value (Timestamp, {seconds}, ISO string, Date) to a JS Date or null.
export const toDate = (v) => {
  if (v == null || v === "") return null;
  try {
    if (v.toDate) return v.toDate();
    if (v.seconds != null) return new Date(v.seconds * 1000);
    const d = new Date(v);
    return isNaN(d) ? null : d;
  } catch { return null; }
};

// Never render a raw Timestamp/object in JSX — always format via these.
export const fmtTs = (v) => {
  const d = toDate(v);
  return d ? d.toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—";
};
export const fmtDate = (v) => {
  const d = toDate(v);
  return d ? d.toLocaleDateString("en-IN", { dateStyle: "medium" }) : "—";
};

// Safe text: returns "—" for null/empty/objects (prevents "objects are not valid as React child").
export const text = (v, fallback = "—") => {
  if (v == null || v === "") return fallback;
  if (typeof v === "object") {
    if (v.toDate || v.seconds != null) return fmtTs(v);
    return fallback;
  }
  return String(v);
};

// Join an array of strings safely.
export const list = (v, sep = ", ", fallback = "—") =>
  Array.isArray(v) && v.length ? v.filter(Boolean).map((x) => (typeof x === "object" ? "" : String(x))).filter(Boolean).join(sep) : fallback;

export const pct = (num, den) => (den > 0 ? Math.round((num / den) * 100) : 0);
